import { render, staticRenderFns } from "./OnTimePercent.vue?vue&type=template&id=61c6b1fa"
import script from "./OnTimePercent.vue?vue&type=script&lang=js"
export * from "./OnTimePercent.vue?vue&type=script&lang=js"
import style0 from "./OnTimePercent.vue?vue&type=style&index=0&id=61c6b1fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports